<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showRecruitmentContent") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-end">
        <v-chip :color="data.is_active ? 'green' : 'red'" text-color="white">
          {{ data.is_active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Company Logo -->
          <base-image-upload-input
            v-if="data.company_logo"
            col="12"
            identifier="company_logo"
            :preSelectedImage="data.company_logo"
            :placeholder="$t('PLACEHOLDERS.companyLogo')"
            disabled
          />
          <!-- End:: Company Logo -->

          <!-- Start:: Company Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.companyName')"
            v-model.trim="data.company_name"
            disabled
          />
          <!-- End:: Company Name Input -->

          <!-- Start:: Company Link Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.companyLink')"
            v-model.trim="data.company_link"
            disabled
          />
          <!-- End:: Company Link Input -->

          <!-- Start:: Jobs Names -->
          <!-- Start:: Jobs Multi-Select -->
          <base-select-input
            col="12"
            :optionsList="activeJobs"
            :placeholder="$t('PLACEHOLDERS.jobs')"
            v-model="data.jobs_names"
            disabled
          />
          <!-- End:: Jobs Multi-Select -->
          <!-- End:: Jobs Names -->

          <!-- Start:: Description Arabic Input -->
          <base-input
            col="6"
            type="textarea"
            rows="5"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.description_ar"
            disabled
          />
          <!-- End:: Description Arabic Input -->

          <!-- Start:: Description English Input -->
          <base-input
            col="6"
            type="textarea"
            rows="5"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.description_en"
            disabled
          />
          <!-- End:: Description English Input -->

          <!-- Start:: Created At Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.createdAt')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->
        </div>
      </form>
      <!-- ==== End:: Main Data ==== -->
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowRecruitmentContent",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Data
      data: {
        company_logo: null,
        company_name: null,
        company_link: null,
        jobs_names: [],
        description_ar: null,
        description_en: null,
        is_active: false,
        created_at: null,
      },
      activeJobs: [],
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `recruitment_contents/${this.id}`,
        });

        const recruitmentContent = res.data.data.data;

        this.data.company_logo =
          recruitmentContent.job?.company?.avatar ||
          recruitmentContent.jobs?.[0]?.company?.avatar;
        this.data.company_name =
          recruitmentContent.job?.company?.name ||
          recruitmentContent.jobs?.[0]?.company?.name;
        this.data.company_link = recruitmentContent.company_link;

        // Extract job names from jobs array
        this.data.jobs_names = recruitmentContent.job;
        if (recruitmentContent.jobs && recruitmentContent.jobs.length > 0) {
          // this.data.jobs_names = recruitmentContent.jobs.map((job) => job.name);
        }

        this.data.description_ar =
          recruitmentContent.description_ar || recruitmentContent.description;
        this.data.description_en =
          recruitmentContent.description_en || recruitmentContent.description;
        this.data.is_active = recruitmentContent.is_active;
        this.data.created_at = recruitmentContent.created_at;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Show

    // Start:: Get Active Jobs
    async getActiveJobs() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "jobs",
          params: {
            page: 0,
            limit: 0,
            is_active: 1,
          },
        });
        this.activeJobs = res.data.data.data?.map((job) => ({
          id: job.id,
          name: job.name,
          value: job.id,
        }));
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
    // End:: Get Active Jobs
  },

  async created() {
    await this.getDataToShow();
    await this.getActiveJobs();
  },
};
</script>
